
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenObject } from './GenObject';
import moment from 'moment';

export class GenEventResultGroup {

    advisoryId: string;
    anlId: number;
    boundary: number[];
    customers: number;
    eventId: number;
    extra: { [key: string]: GenObject };
    forecastTo: moment.Moment;
    hasResults: boolean;
    resultId: string;
    resultTime: moment.Moment;

    constructor();
    constructor( jsonObj: any );
    constructor( genEventResultGroup: GenEventResultGroup);

    constructor( input?: GenEventResultGroup ) {
        if ( input && typeof input !== 'number' ) {
            this.advisoryId = input.advisoryId; // string [string]
            this.anlId = input.anlId; // int [number]
            this.boundary = input.boundary; // list [number]
            this.customers = input.customers; // int [number]
            this.eventId = input.eventId; // int [number]
            if( input.extra ) {
               let keys = Object.keys( input.extra );
               this.extra = {};
               for( let i = 0, len = keys.length; i < len; ++i) {
                   let key = keys[i];
                   this.extra[ key ] = input.extra[ key ];
               }
            }
            if ( input.forecastTo && typeof input.forecastTo === 'string' ) {
                this.forecastTo = moment(input.forecastTo).utc();
            } else {
                this.forecastTo = input.forecastTo;
            }
            this.hasResults = input.hasResults; // boolean [boolean]
            this.resultId = input.resultId; // string [string]
            if ( input.resultTime && typeof input.resultTime === 'string' ) {
                this.resultTime = moment(input.resultTime).utc();
            } else {
                this.resultTime = input.resultTime;
            }
       }
    }

    static jsonResponseToList(arr: any[]): GenEventResultGroup[] {
        if (arr && arr.map) {
          return arr.map(a => new GenEventResultGroup(a));
        } else {
          return [];
        }
    }
}

